/**
 * Base64 编解码
 *
 * 小程序运行时没有 btoa / atob，这里基于 UTF-8 字节自行实现，
 * 因此中文和 emoji 都能正确处理。
 */

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

function toUtf8Bytes(str) {
	const bytes = [];
	for (let i = 0; i < str.length; i++) {
		let code = str.charCodeAt(i);
		if (code < 0x80) {
			bytes.push(code);
		} else if (code < 0x800) {
			bytes.push(0xc0 | (code >> 6), 0x80 | (code & 0x3f));
		} else if (code >= 0xd800 && code <= 0xdbff && i + 1 < str.length) {
			const next = str.charCodeAt(i + 1);
			code = 0x10000 + ((code - 0xd800) << 10) + (next - 0xdc00);
			i++;
			bytes.push(
				0xf0 | (code >> 18),
				0x80 | ((code >> 12) & 0x3f),
				0x80 | ((code >> 6) & 0x3f),
				0x80 | (code & 0x3f)
			);
		} else {
			bytes.push(0xe0 | (code >> 12), 0x80 | ((code >> 6) & 0x3f), 0x80 | (code & 0x3f));
		}
	}
	return bytes;
}

function fromUtf8Bytes(bytes) {
	let result = '';
	let i = 0;
	while (i < bytes.length) {
		const byte = bytes[i];
		if (byte < 0x80) {
			result += String.fromCharCode(byte);
			i += 1;
		} else if (byte >= 0xc0 && byte < 0xe0) {
			result += String.fromCharCode(((byte & 0x1f) << 6) | (bytes[i + 1] & 0x3f));
			i += 2;
		} else if (byte >= 0xe0 && byte < 0xf0) {
			result += String.fromCharCode(((byte & 0x0f) << 12) | ((bytes[i + 1] & 0x3f) << 6) | (bytes[i + 2] & 0x3f));
			i += 3;
		} else {
			const code = ((byte & 0x07) << 18) | ((bytes[i + 1] & 0x3f) << 12)
				| ((bytes[i + 2] & 0x3f) << 6) | (bytes[i + 3] & 0x3f);
			const adjusted = code - 0x10000;
			result += String.fromCharCode(0xd800 + (adjusted >> 10), 0xdc00 + (adjusted & 0x3ff));
			i += 4;
		}
	}
	return result;
}

export function base64Encode(text) {
	const bytes = toUtf8Bytes(String(text));
	let result = '';
	for (let i = 0; i < bytes.length; i += 3) {
		const b0 = bytes[i];
		const b1 = bytes[i + 1];
		const b2 = bytes[i + 2];

		result += CHARS[b0 >> 2];
		result += CHARS[((b0 & 0x03) << 4) | (b1 === undefined ? 0 : b1 >> 4)];
		result += b1 === undefined ? '=' : CHARS[((b1 & 0x0f) << 2) | (b2 === undefined ? 0 : b2 >> 6)];
		result += b2 === undefined ? '=' : CHARS[b2 & 0x3f];
	}
	return result;
}

export function base64Decode(text) {
	const clean = String(text).replace(/[^A-Za-z0-9+/=]/g, '');
	if (clean.length % 4 !== 0) {
		throw new Error('不是合法的 Base64，长度必须是 4 的倍数');
	}

	const bytes = [];
	for (let i = 0; i < clean.length; i += 4) {
		const c0 = CHARS.indexOf(clean[i]);
		const c1 = CHARS.indexOf(clean[i + 1]);
		const c2 = clean[i + 2] === '=' ? -1 : CHARS.indexOf(clean[i + 2]);
		const c3 = clean[i + 3] === '=' ? -1 : CHARS.indexOf(clean[i + 3]);

		if (c0 < 0 || c1 < 0) {
			throw new Error('包含无法识别的 Base64 字符');
		}

		bytes.push((c0 << 2) | (c1 >> 4));
		if (c2 >= 0) bytes.push(((c1 & 0x0f) << 4) | (c2 >> 2));
		if (c3 >= 0) bytes.push(((c2 & 0x03) << 6) | c3);
	}

	return fromUtf8Bytes(bytes);
}
